<path
    d="M25 4.34468C25 3.1491 23.4943 2.55033 22.6139 3.39576L7.687 17.8167H0L8.3984e-05 31.2365H7.15303L22.6139 45.6043C23.4943 46.4497 25 45.8508 25 44.6553V4.34468Z"
    fill="white"
/>
<path
    d="M39 24.5001C39 29.5 34.5163 32 31 32C31 32 31 28.6422 31 24.5001C31 20.3578 31 17 31 17C34.5163 17 39 19.5 39 24.5001Z"
    fill="white"
/>
<path
    d="M31 6V11.2857C37.7857 11.2857 44.5714 16.5715 44.5714 24.5002C44.5714 32.4285 37.7857 37.7144 31 37.7144V43C39.1429 43 50 37.7144 50 24.5002C50 11.2857 39.1429 6 31 6Z"
    fill="white"
/>
